import { IBrand } from "./../ibrand";

export const Brand: IBrand = {
  navbarTitle: 'Sustainable Interaction',
  brandTitle: 'Sustainable Interaction',
  brandName: "si",
  mockBackendUrl: 'http://localhost:8000',
  prodBackendUrl: '/api',
  dialogUrl: 'assets/dialogs/',
  targetOrigin: '*',
  defaultLocale: 'sv-SE',
  supportedLocales: ['sv-SE'],
  messagesEnabled: true,
  showQuestionCounter: false,
  nextButtonInQuestion: false,
  resultLayout: 'separate',
  selfAssessmentFirst: false,
  tipsLayout: 'grid',
  cmsMockUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsProdUrl: 'https://si-sandbox.orchard.silabs.se',
  cmsMockApiKey: 'ABCD1234',
  cmsProdApiKey: ''
};
